// Compat-label reading for a published version. The registry stores a version's
// compat ranges on the row, but the browsable document still carries the
// registry.compat.* labels it was authored with — the package/version pages read
// them from there. Pure module — node-unit-testable.

export interface CompatLabels {
  /** registry.compat.engine semver range ("" when absent). */
  engine: string;
  /** registry.compat.cli semver range ("" when absent). */
  cli: string;
  /** The retired flat registry.compat value when a document still carries it. */
  legacyFlat: string;
}

/** extractCompat reads the compat labels (split keys + the retired flat key). */
export function extractCompat(labels: Record<string, string>): CompatLabels {
  return {
    engine: labels["registry.compat.engine"] ?? "",
    cli: labels["registry.compat.cli"] ?? "",
    legacyFlat: labels["registry.compat"] ?? "",
  };
}
